import SearchBox from 'components/common/SearchBox';
import { Button, Col, Row } from 'react-bootstrap';

export interface FoodFilterValues {
  food_name: string;
  brand_name: string;
}

interface FoodFilterProps {
  filters: FoodFilterValues;
  onChange: (field: keyof FoodFilterValues, value: string) => void;
  onSearch: () => void;
  onClear: () => void;
  loading?: boolean;
}

const FoodFilter = ({
  filters,
  onChange,
  onSearch,
  onClear,
  loading = false
}: FoodFilterProps) => {
  return (
    <Row className="align-items-end g-2">
      {/* Left: Search fields */}
      <Col xs={12} xl>
        <div className="d-flex flex-column flex-md-row gap-2">
          <SearchBox
            placeholder="Search food name..."
            value={filters.food_name}
            onChange={event => onChange('food_name', event.target.value)}
            onKeyDown={event => {
              if (event.key === 'Enter') {
                event.preventDefault();
                onSearch();
              }
            }}
            className="flex-fill"
            style={{
              width: '100%',
              minWidth: 0
            }}
          />

          <SearchBox
            placeholder="Search brand name..."
            value={filters.brand_name}
            onChange={event => onChange('brand_name', event.target.value)}
            onKeyDown={event => {
              if (event.key === 'Enter') {
                event.preventDefault();
                onSearch();
              }
            }}
            className="flex-fill"
            style={{
              width: '100%',
              minWidth: 0
            }}
          />
        </div>
      </Col>

      {/* Right: Buttons */}
      <Col xs={12} xl="auto" className="mt-1 mt-xl-0">
        <div className="d-flex gap-2">
          <Button
            variant="primary"
            type="button"
            onClick={onSearch}
            disabled={loading}
            className="px-4"
          >
            Search
          </Button>

          <Button
            variant="phoenix-secondary"
            type="button"
            onClick={onClear}
            disabled={loading}
            className="px-4"
          >
            Clear
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default FoodFilter;
